export class PopupEvent {
  constructor(public count: number) {}
}
